const initModal = (formClass, modalClass, modalFormMapping) => {
  const forms = $(formClass);
  const modalHandler = $(modalClass);
  const dimmerHandler = $('.dimmer');

  forms.each(function () {
    const form = $(this);

    form.on('submit', (e) => {
      e.preventDefault();

      if (!form.attr('class').includes('disabled')) {
        for (let modalSelector in modalFormMapping) {
          modalHandler.find(modalSelector).html(form.data(modalFormMapping[modalSelector]));
        }

        modalHandler.data('current_form_id', form.attr('id'));
        modalHandler.modal('show');
      }
    });
  });

  dimmerHandler.on('click', () => {
    modalHandler.trigger('close');
  });

  modalHandler.on('click', '.approve', () => {
    $(`#${modalHandler.data('current_form_id')}`)[0].submit();
  });

  modalHandler.on('click', '.cancel', () => {
    modalHandler.trigger('close');
  });
};

export default initModal;
